export enum CreateUserFormFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  AvatarFileKey = 'avatarFileKey',
}

export type CreateUserFormModel = {
  [CreateUserFormFields.FirstName]: string;
  [CreateUserFormFields.LastName]: string;
  [CreateUserFormFields.Email]: string;
  [CreateUserFormFields.PhoneNumber]: string;
  [CreateUserFormFields.AvatarFileKey]: string;
};
